import { Link } from 'react-router-dom';

const testimonials = [
  {
    stars: 5,
    quote: 'Best Investment Decision Ever',
    review: 'Working with this team transformed my basement into a thriving Airbnb. They handled everything from permits to the first booking. My property now generates $4,500 monthly!',
    avatar: 'https://public.readdy.ai/ai/img_res/5464c396b028ea7795cb1ce4d6ec83f9.jpg',
    name: 'Sarah Mitchell',
    location: 'Seattle, WA'
  },
  {
    stars: 5,
    quote: 'Exceptional Service & Support',
    review: 'From code compliance to revenue optimization, they guided me through every step. The training programs were invaluable. I\'m now a Superhost with consistent 5-star reviews!',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20smiling%20man%20with%20glasses%20and%20beard%2C%20friendly%20business%20professional%2C%20simple%20clean%20neutral%20background%2C%20corporate%20photography%20style&width=200&height=200&seq=avatar-002&orientation=squarish',
    name: 'Michael Chen',
    location: 'Portland, OR'
  },
  {
    stars: 5,
    quote: 'Turned My Property Into Profit',
    review: 'I was overwhelmed by the regulations and requirements. This team made it simple and stress-free. Their contractor network delivered quality work on time and within budget.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20smiling%20woman%20with%20blonde%20hair%2C%20friendly%20business%20professional%2C%20simple%20clean%20neutral%20background%2C%20corporate%20photography%20style&width=200&height=200&seq=avatar-003&orientation=squarish',
    name: 'Jennifer Rodriguez',
    location: 'Austin, TX'
  }
];

export default function Testimonials() {
  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            What Our Clients Say
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed px-4">
            Real results from real property owners who trusted us with their Airbnb journey
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-6 sm:p-8 rounded-2xl border-2 border-gray-100 hover:border-[#FF6B6B] transition-all duration-300 hover:shadow-xl"
            >
              {/* Rating */}
              <div className="flex gap-1 mb-4 sm:mb-6">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg sm:text-xl w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center"></i>
                ))}
              </div>

              {/* Quote */}
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-6 sm:mb-8 italic">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-[#FF6B6B]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-[#FF6B6B] font-bold text-lg sm:text-xl">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-bold text-gray-900 text-base sm:text-lg">{testimonial.name}</p>
                  <p className="text-xs sm:text-sm text-gray-600">{testimonial.location}</p>
                  <p className="text-xs sm:text-sm text-[#FF6B6B] font-semibold mt-1">{testimonial.result}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 sm:mt-12 md:mt-16">
          <Link
            to="/contact"
            className="inline-block bg-[#FF6B6B] text-white px-8 sm:px-10 py-4 sm:py-5 rounded-lg font-semibold text-base sm:text-lg hover:bg-[#ff5252] transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            Start Your Success Story
          </Link>
        </div>
      </div>
    </section>
  );
}
